import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpParams,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoggingService } from '../shared/services/logging/logging.service';
import formatForApiCall from './formatForApiCall';

const log = new LoggingService();

function shouldFormatRequestBody(req: HttpRequest<unknown>): boolean {
    const body = req.body;
    if (body == null) {
        return false;
    }
    if (typeof body === 'string' || body instanceof FormData || body instanceof HttpParams) {
        return false;
    }

    const contentType = req.headers.get('Content-Type') ?? '';
    if (contentType.includes('application/x-www-form-urlencoded')) {
        return false;
    }

    return true;
}

@Injectable()
export class PUTInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let cloneReq = req.clone();
        const method = req.method.toLocaleLowerCase();
        if (
            (method === 'put' || method === 'post') &&
            shouldFormatRequestBody(req)
        ) {
            const body = req.body;
            let newBody;
            if (Array.isArray(body)) {
                newBody = body.map(x => formatForApiCall(x));
            } else {
                newBody = formatForApiCall(body);
            }
            cloneReq = req.clone({ body: newBody });
            // log.verbose({type: 'PUTInterceptor', req, cloneReq});
        }
        return next.handle(cloneReq);
    }
}
